// extracted by mini-css-extract-plugin
module.exports = {"root":"Link_root__i3hRx","secondary":"Link_secondary__-BYQj","primary":"Link_primary__1jM9t","underline":"Link_underline__2lGI_"};